// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"d0a077da","937":"3c9ab0cd"}[chunkId] + ".chunk.css";
};